import { AxiosHeaders, AxiosInstance } from 'axios';
import { BASE_URL } from '../../constant/global';
import NetworkInstanceProvider from './network';
import {
  APIRequestMethods,
  APIServiceRequestInterface,
  APIServiceRequestMethodInterface,
  APIServiceRequestMethodPropsInterface,
  APIServiceRequestPropsInterface,
} from './types';

class APIService {
  private static instance: AxiosInstance;
  private static protectedInstance: AxiosInstance;

  constructor(baseURL: string = BASE_URL ?? '') {
    APIService.instance = NetworkInstanceProvider.initiateNetworkInstance({
      baseURL,
      isProtected: false,
    });
    APIService.protectedInstance =
      NetworkInstanceProvider.initiateNetworkInstance({
        baseURL,
        isProtected: true,
      });
  }

  private apiRequest: APIServiceRequestInterface = <ResponseInterface>({
    method,
    path: url,
    data,
    params,
    paramsSerializer,
    headers: requestHeaders,
    responseType,
    isProtected = true,
  }: APIServiceRequestPropsInterface) => {
    if (isProtected) {
      return APIService.protectedInstance.request<ResponseInterface>({
        method,
        url,
        data,
        params,
        paramsSerializer,
        headers: requestHeaders as AxiosHeaders,
        responseType,
      });
    }
    return APIService.instance.request<ResponseInterface>({
      method,
      url,
      data,
      params,
      headers: requestHeaders as AxiosHeaders,
      responseType,
    });
  };

  public get: APIServiceRequestMethodInterface = <ResonseInterface>(
    props: APIServiceRequestMethodPropsInterface,
  ) => {
    return this.apiRequest<ResonseInterface>({
      method: APIRequestMethods.GET,
      ...props,
    });
  };

  public post: APIServiceRequestMethodInterface = <ResonseInterface>(
    props: APIServiceRequestMethodPropsInterface,
  ) =>
    this.apiRequest<ResonseInterface>({
      method: APIRequestMethods.POST,
      ...props,
    });

  public patch: APIServiceRequestMethodInterface = <ResonseInterface>(
    props: APIServiceRequestMethodPropsInterface,
  ) =>
    this.apiRequest<ResonseInterface>({
      method: APIRequestMethods.PATCH,
      ...props,
    });

  public put: APIServiceRequestMethodInterface = <ResonseInterface>(
    props: APIServiceRequestMethodPropsInterface,
  ) =>
    this.apiRequest<ResonseInterface>({
      method: APIRequestMethods.PUT,
      ...props,
    });

  public delete: APIServiceRequestMethodInterface = <ResonseInterface>(
    props: APIServiceRequestMethodPropsInterface,
  ) =>
    this.apiRequest<ResonseInterface>({
      method: APIRequestMethods.DELETE,
      ...props,
    });
}

export default APIService;
